/* eslint-disable jsx-a11y/anchor-is-valid */
import { Route, Routes } from "react-router-dom";
import { createContext } from "react";
import { Home } from "../../module/home/component/home";

const HomeContext = createContext();

const HomeWrapper = () => {
  const value = {};

  return (
    <HomeContext.Provider value={value}>
      <Routes>
        <Route path="/*" element={<Home />} />
      </Routes>
    </HomeContext.Provider>
  );
};

export { HomeWrapper };
